const EmptyClosure = (): void => {};

export default EmptyClosure;
